import { FC } from "react";

import TraceDetailContent from "./TraceDetailContent";
import { useTraceDetailState } from "./hooks/useTraceDetailState";

const TraceDetail: FC = () => {
  const traceDetailState = useTraceDetailState();

  return <TraceDetailContent {...traceDetailState} />;
};

export default TraceDetail;
